/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1IndividualpaymentFinancialPeopleFinancialpersonid200,
  PutApiV1IndividualpaymentFinancialPeopleFinancialpersonid400,
  PutApiV1IndividualpaymentFinancialPeopleFinancialpersonid401,
  PutApiV1IndividualpaymentFinancialPeopleFinancialpersonid500,
  PutApiV1IndividualpaymentFinancialPeopleFinancialpersonidMutationRequest,
  PutApiV1IndividualpaymentFinancialPeopleFinancialpersonidMutationResponse,
  PutApiV1IndividualpaymentFinancialPeopleFinancialpersonidPathParams,
} from "../../types/individualPaymentEditorsController/PutApiV1IndividualpaymentFinancialPeopleFinancialpersonid.ts";
import { individualPaymentSaveViewModelSchema } from "../individualPaymentSaveViewModelSchema.ts";

export const putApiV1IndividualpaymentFinancialPeopleFinancialpersonidPathParamsSchema =
  z.object({
    financialPersonId: z.coerce.number().int(),
  }) as unknown as ToZod<PutApiV1IndividualpaymentFinancialPeopleFinancialpersonidPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1IndividualpaymentFinancialPeopleFinancialpersonid200Schema =
  z.any() as unknown as ToZod<PutApiV1IndividualpaymentFinancialPeopleFinancialpersonid200>;

/**
 * @description Regra de negócio violada
 */
export const putApiV1IndividualpaymentFinancialPeopleFinancialpersonid400Schema =
  z.any() as unknown as ToZod<PutApiV1IndividualpaymentFinancialPeopleFinancialpersonid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1IndividualpaymentFinancialPeopleFinancialpersonid401Schema =
  z.any() as unknown as ToZod<PutApiV1IndividualpaymentFinancialPeopleFinancialpersonid401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1IndividualpaymentFinancialPeopleFinancialpersonid500Schema =
  z.any() as unknown as ToZod<PutApiV1IndividualpaymentFinancialPeopleFinancialpersonid500>;

export const putApiV1IndividualpaymentFinancialPeopleFinancialpersonidMutationRequestSchema =
  z.lazy(
    () => individualPaymentSaveViewModelSchema,
  ) as unknown as ToZod<PutApiV1IndividualpaymentFinancialPeopleFinancialpersonidMutationRequest>;

export const putApiV1IndividualpaymentFinancialPeopleFinancialpersonidMutationResponseSchema =
  z.lazy(
    () => putApiV1IndividualpaymentFinancialPeopleFinancialpersonid200Schema,
  ) as unknown as ToZod<PutApiV1IndividualpaymentFinancialPeopleFinancialpersonidMutationResponse>;
